import { landingPageInitialState } from "./uiLandingPageLandingState";

export const makeLandingPageActions = (set, get) => ({
  setSelectedTab: (tab) =>
    set((s) => ({ landingPage: { ...s.landingPage, selectedTab: tab } })),
  resetLandingPage: () => set({ landingPage: landingPageInitialState }),
  // Device flags updater
  setDeviceFlags: ({ isTouch, isTablet, viewportWidth, viewportHeight }) =>
    set((s) => ({
      landingPage: {
        ...s.landingPage,
        isTouch: !!isTouch,
        isTablet: !!isTablet,
        viewportWidth:
          typeof viewportWidth === "number"
            ? viewportWidth
            : s.landingPage.viewportWidth,
        viewportHeight:
          typeof viewportHeight === "number"
            ? viewportHeight
            : s.landingPage.viewportHeight,
      },
    })),
});
